// import httpClient from '@/plugins/axios'

export default {
  actions: {
    getInsurancePolicy () {
      return this.dispatch('getPolicy')
    },
    getInsuranceEmail () {
      return this.dispatch('getFormData', [
        'email'
      ])
        .then((fields) => fields.email)
    }
  }
}
